import React, { useState, useEffect } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

function UpdatePassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if we have a valid session
    const checkSession = async () => {
      console.log('=== CHECKING SESSION ON UPDATE PASSWORD PAGE ===');
      const { data: { session }, error } = await supabase.auth.getSession();
      console.log('Session:', session ? 'exists' : 'null');
      console.log('Session error:', error);

      if (session) {
        console.log('User ID:', session.user.id);
        console.log('User email:', session.user.email);
        console.log('User metadata:', session.user.user_metadata);
      }

      if (!session) {
        console.log('No session found, redirecting to login');
        navigate('/login', { replace: true });
      }
    };

    checkSession();
  }, [navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      console.log('=== UPDATE PASSWORD START ===');

      // Check current session
      const { data: { session }, error: sessionError } = await supabase.auth.getSession();
      console.log('Current session:', session ? 'exists' : 'null');
      console.log('Session error:', sessionError);

      if (!session) {
        throw new Error('لا يوجد جلسة نشطة. الرجاء المحاولة مرة أخرى');
      }

      if (password !== confirmPassword) {
        throw new Error('كلمات المرور غير متطابقة');
      }

      if (password.length < 6) {
        throw new Error('كلمة المرور يجب أن تكون 6 أحرف على الأقل');
      }

      console.log('Updating password for user:', session.user.id);
      console.log('User email:', session.user.email);

      const { data: updateData, error: updateError } = await supabase.auth.updateUser({
        password: password
      });

      console.log('Update result:', updateData);
      console.log('Update error:', updateError);

      if (updateError) {
        console.error('Password update failed:', updateError);
        throw updateError;
      }

      console.log('Password updated successfully!');
      console.log('Signing out...');

      // Sign out and redirect to login
      await supabase.auth.signOut();

      console.log('Redirecting to login...');
      navigate('/login', { replace: true });
    } catch (err) {
      console.error('=== UPDATE PASSWORD ERROR ===');
      console.error('Error:', err);
      setError(err instanceof Error ? err.message : 'حدث خطأ أثناء تحديث كلمة المرور');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 flex flex-col">
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm bg-white rounded-3xl shadow-lg p-8">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-semibold text-gray-800 mb-2">تحديث كلمة المرور</h1>
            <p className="text-gray-600">أدخل كلمة المرور الجديدة</p>
          </div>

          {error && (
            <div className="mb-4 p-3 bg-red-50 text-red-600 rounded-lg text-sm">
              {error}
            </div>
          )}

          <form className="space-y-4" onSubmit={handleSubmit}>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="كلمة المرور الجديدة"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:border-blue-500"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>

            <div className="relative">
              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="تأكيد كلمة المرور"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:border-blue-500"
                required
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"
              >
                {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 bg-[#F87171] text-white rounded-xl hover:bg-[#EF4444] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'جاري التحديث...' : 'تحديث كلمة المرور'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default UpdatePassword;